import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import QRCode from "react-qr-code";
import { Smartphone, X } from 'lucide-react';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from './ui/dialog';

export default function MobileConnect() {
    const { t } = useTranslation();
    const [ip, setIp] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (isOpen && !ip) {
            fetch('http://localhost:3001/api/info')
                .then(res => res.json())
                .then(data => setIp(data.data?.ip || 'localhost'))
                .catch(() => setIp('localhost'));
        }
    }, [isOpen, ip]);

    const url = ip ? `http://${ip}:3000` : '';

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger asChild>
                <Button 
                    variant="ghost" 
                    size="icon" 
                    className="text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"
                >
                    <Smartphone className="h-5 w-5" />
                    <span className="sr-only">{t('connect_mobile')}</span>
                </Button>
            </DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{t('connect_mobile')}</DialogTitle>
                </DialogHeader>
                
                <div className="flex flex-col items-center space-y-4">
                    {ip ? (
                        <>
                            <div className="bg-white p-4 rounded-xl shadow-inner">
                                <QRCode value={url} size={200} />
                            </div>
                            <p className="text-center text-sm text-gray-500">
                                {t('scan_qr')}<br />
                                <span className="font-mono bg-gray-100 px-2 py-1 rounded text-xs mt-2 inline-block">{url}</span>
                            </p>
                            <p className="text-xs text-yellow-600 bg-yellow-50 p-2 rounded text-center w-full">
                                {t('same_network')}
                            </p>
                        </>
                    ) : (
                        <p>{t('loading')}</p>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
}